<template>
  <div
    v-if="canSee"
    @click="trackEventClickGoogle()"
    class="h-nav-menu-item"
    :class="[
      {'h-nav-active-item text-primary font-medium' : activeLink},
      {'disabled-item pointer-events-none' : isDisabled},
      {'addExcel': slug === 'excel'},
    ]" >

      <router-link
        v-if="to"
        exact
        :class="[{'router-link-active': activeLink}, 'nav-link flex items-center']"
        :to="to"
        :target="target" >
          <vs-icon v-if="!featherIcon && icon != 'FaqIcon'" :icon-pack="iconPack" :icon="icon" />
          <svg v-else-if="icon == 'FaqIcon'" xmlns="http://www.w3.org/2000/svg" class="mr-3" width="18" height="18" viewBox="0 0 18 18">
            <path id="Path_1649" data-name="Path 1649" d="M452.2,187.375a9,9,0,1,0,9,9A9,9,0,0,0,452.2,187.375Zm0,16.594a7.594,7.594,0,1,1,7.594-7.594A7.59,7.59,0,0,1,452.2,203.969Zm2.813-9.264a2.817,2.817,0,0,1-2.109,2.723v1.144a.7.7,0,1,1-1.406,0v-1.758a.7.7,0,0,1,.7-.7,1.406,1.406,0,1,0-1.406-1.406.7.7,0,1,1-1.406,0,2.813,2.813,0,0,1,5.625,0Zm-1.933,5.977a.879.879,0,1,1-.879-.879A.879.879,0,0,1,453.083,200.682Z" transform="translate(-443.204 -187.375)" fill="#6e6b7b"/>
          </svg>
          <feather-icon v-else :class="iconClasses" :icon="icon" />
          <slot />
      </router-link>

      <a v-else :target="target" :href="href" class="nav-link flex items-center">
        <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" />
        <feather-icon v-else :class="iconClasses" :icon="icon" />
        <slot />
      </a>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import gTag from "@/mixins/gtag.js"

export default {
  name: 'v-nav-menu-item',
  mixins: [gTag],
  props: {
    icon        : { type: String,                 default: ''               },
    iconSmall   : { type: Boolean,                default: false            },
    iconPack    : { type: String,                 default: 'material-icons' },
    href        : { type: [String, null],         default: '#'              },
    to          : { type: [String, Object, null], default: null             },
    slug        : { type: String,                 default: null             },
    index       : { type: [String, Number],       default: null             },
    featherIcon : { type: Boolean,                default: true             },
    target      : { type: String,                 default: '_self'          },
    isDisabled  : { type: Boolean,                default: false            },
    header      : { type: Object },
    name      : { type: String }
  },
  computed: {
    iconClasses () {
      return this.iconSmall ? 'w-3 h-3 mr-3' : 'w-5 h-5 mr-3'
    },
    canSee () {
      return true
    },
    activeLink () {
      return !!((this.to === this.$route.path || this.$route.meta.parent === this.slug) && this.to)
    }
  },
  methods: {
    ...mapActions('dataList', ['resendWithNewOrder']),
    trackEventClickGoogle() {
      if (this.to === '/addOrder') {
        // Clear the resend state before navigating to Add Order
        this.resendWithNewOrder({});

        this.googleEventTrack('الضغط على زر اضافة طلب', 'navmenu', 'add_new_order_item_nav_menu')
      }else if (this.to === '/AddOrderWithExcel') {
        this.googleEventTrack('الضغط على زر اضافة طلبات بالاكسيل', 'navmenu', 'add_new_order_excel_item_nav_menu')
      }else if (this.header && this.header.i18n === 'orders') {
        this.googleEventTrack(`الضغط علي زر ${this.name}`, 'navmenu', 'order_item_nav_menu')
      }
    }
  }
}

</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/horizontalNavMenuItem.scss";
</style>
